export default {
    STATUS_CODE: {
        UNAUTHORIZED: 401,
    },
    ERROR_MESSAGE: {
        JWT_TOKEN_INVALID: 'JWT MALFORMED / Invalid token'
    },
    WEBHOOK_MESSAGE: 'Webhook Message API call failed',
    WEBHOOK_EVENT: 'Webhook Event API call failed',
    WEBHOOK_HISTORY: 'Webhook History API call failed',
    AGENT_WEBHOOK_MESSAGE: 'Agent Webhook Message API call failed',
    AGENT_INFO_WEBHOOK_MESSAGE: 'Agent Webhook Info API call failed',
    SUCCESS: 'SUCCESS',
    REQUEST_ACCEPTED: 'REQUEST_ACCEPTED',
    DEFAULT: {
        STATUS_CODE: 'FAILURE',
        STATUS_MSG: 'Could not process request',
        EXCEPTION_CODE: 'Something bad happened',
        STATUS: 500
    }
}